export default {
  en: {
    error_sample_data: "Could not get sample data. See developer console for details.",
    error_invalid_json: "NOTE: This example contains invalid JSON for ${0}.",
    error_json_additional_property: "  (additional property: \"{0}\")",
    error_missing_model: "Missing Model id",
    error_missing_stereotype: "Missing StereoType",
    error_missing_service_model: "Missing ServiceModel id"
  },
  es: {
    error_sample_data: "No se pudo obtener datos de ejemplo. Mire la consola de desarrollo para más detalles.",
    error_invalid_json: "NOTA: Este ejemplo contiene JSON inválido por ${0}.",
    error_json_additional_property: "  (propiedad adicional: \"{0}\")",
    error_missing_model: "Modelo no encontrado",
    error_missing_stereotype: "Esterotipo no encontrado",
    error_missing_service_model: "Model de Servicio no encontrado"
  },
  ca: {
    error_sample_data: "No s'han pogut obtenir dades d'exemple. Miri la consola de desenvolupament per a més detalls.",
    error_invalid_json: "NOTA: Aquest exemple conté JSON invàlid per ${0}.",
    error_json_additional_property: "  (propietat adicional: \"{0}\")",
    error_missing_model: "Model no trobat",
    error_missing_stereotype: "Esterotip no tobat",
    error_missing_service_model: "Model de Servei no trobat",
  }
};
